import React from 'react';
import LivretsRoot from 'containers/Livrets/Loadable';
import LockedPage from 'components/LockPage/Loadable';
import NewLivretOrchestrator from 'containers/Livrets/components/NewLivret/Loadable';
import { PageTrackerWrapper } from 'queries/user/track';
import ConfigPeriodes from 'containers/Livrets/ConfigPeriodes/Loadable';
import LivretEval from 'containers/Livrets/LivretEval/Loadable';
import LivretEvalEleve from 'containers/Livrets/LivretEval/LoadableLivretEvalEleve';
import FixUser from 'containers/Livrets/LivretEval/FixUser/Loadable';
import MissingUai from 'containers/Livrets/LivretEval/MissingUai/Loadable';
import MissingDirector from 'containers/Livrets/LivretEval/MissingDirector/Loadable';
import LivretEleveRoot from 'containers/Livrets/LivretEval/LivretEleve/Loadable';
import Config from 'containers/Livrets/LivretEval/Config/Loadable';
import LivretEvalRoute from 'containers/Livrets/LivretEval/LoadableLivretEval';
import LivretsEvalList from 'containers/Livrets/List/Loadable';
import Onde from 'containers/Livrets/LivretEval/ConfigurationINE/Onde/Loadable';
import INEOptions from 'containers/Livrets/LivretEval/ConfigurationINE/INEOptions/Loadable';
import ManualIDBE from 'containers/Livrets/LivretEval/ConfigurationINE/ManualIDBe/Loadable';
import ManualINE from 'containers/Livrets/LivretEval/ConfigurationINE/ManualINE/Loadable';
import { screenshotUrls } from 'containers/screenshotUrls';
import { TitleHelmet } from 'components/TitleHelmet/TitleHelmet';

export const LivretsRoutes = {
  path: 'livrets',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.carnetLivret.livrets" />
      <LivretsRoot />
    </>
  ),
  children: [
    {
      path: 'locked',
      element: (
        <LockedPage featureKey="livret" s3ImagePath={screenshotUrls.livret} />
      ),
    },
    {
      path: 'new/:step?',
      element: <NewLivretOrchestrator />,
    },
    {
      path: 'config-periodes',
      element: (
        <PageTrackerWrapper title="Livrets - configuration des périodes">
          <ConfigPeriodes />
        </PageTrackerWrapper>
      ),
    },
    {
      path: ':livretEvalId',
      element: <LivretEval />,
      children: [
        {
          path: 'eleves/:eleveId',
          element: (
            <PageTrackerWrapper title="Livrets - livret élève">
              <LivretEvalEleve />
            </PageTrackerWrapper>
          ),
          children: [
            {
              path: 'configure-ine',
              children: [
                {
                  path: 'manual',
                  element: <ManualINE />,
                },
                {
                  path: 'onde',
                  element: <Onde />,
                },
                {
                  index: true,
                  element: <INEOptions />,
                },
              ],
            },
            {
              path: 'configure-idbe',
              children: [
                {
                  path: 'manual',
                  element: <ManualIDBE />,
                },
                {
                  path: 'onde',
                  element: <Onde />,
                },
                {
                  index: true,
                  element: <INEOptions idbe />,
                },
              ],
            },
            {
              path: 'configure-user',
              element: <FixUser />,
            },
            {
              path: 'configure-uai',
              element: <MissingUai />,
            },
            {
              path: 'configure-director',
              element: <MissingDirector />,
            },
            {
              index: true,
              element: <LivretEleveRoot />,
            },
          ],
        },
        {
          path: 'config',
          element: <Config />,
        },
        {
          index: true,
          element: (
            <PageTrackerWrapper title="Livrets - livret éval">
              <LivretEvalRoute />
            </PageTrackerWrapper>
          ),
        },
      ],
    },
    {
      index: true,
      element: (
        <PageTrackerWrapper title="Livrets - liste">
          <LivretsEvalList />
        </PageTrackerWrapper>
      ),
    },
  ],
};
